import type { LeadFieldsCountry } from "../schemas/lead";

import {
  normalizeCanPostalCode,
  normalizeUsaZipCode,
} from "@homeinstead/locale";

/**
 * Normalizes a postal/ZIP code value before schema validation.
 *
 * - **Canada:** uppercases and ensures exactly one space between the FSA
 *   (first 3 chars) and LDU (last 3 chars). Input may be spaced or unspaced
 *   ("m4b1b3" → "M4B 1B3", "M4B 1B3" → "M4B 1B3").
 * - **USA:** keeps the five-digit ZIP when given ZIP+4 or 9-digit ZIP input.
 *
 * @example
 * normalizePostalCode("m4b1b3", "can")  // "M4B 1B3"
 * normalizePostalCode("M4B 1B3", "can") // "M4B 1B3" (idempotent)
 * normalizePostalCode("02139", "usa")      // "02139"
 * normalizePostalCode("02139-1234", "usa") // "02139"
 */
function normalizePostalCode(
  rawValue: string,
  country: LeadFieldsCountry,
): string {
  if (country === "can") {
    return normalizeCanPostalCode(rawValue);
  }

  return normalizeUsaZipCode(rawValue);
}

export { normalizePostalCode };
